export const BuildInfo = {timestamp:1779921952000}
